import script from "./PageDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageDetail.vue?vue&type=script&setup=true&lang=ts"

import "./PageDetail.vue?vue&type=style&index=0&id=9c5efdf2&lang=scss&scoped=true"

import exportComponent from "/Users/mayo/htdocs/halp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c5efdf2"]])

export default __exports__